// extracted by mini-css-extract-plugin
export default {"preferences":"preferences-box_preferences__zBNQ6","toggleLabel":"preferences-box_toggleLabel__qq63k","dropdownLabel":"preferences-box_dropdownLabel__311cm"};